import type { LighthouseAuditDetails } from "../types/analyzer";

interface AuditsProps {
	audits: Record<string, LighthouseAuditDetails>;
}

function Audits({ audits }: AuditsProps) {
	return (
		<div className="audit-grid">
			{Object.entries(audits).map(([key, audit]) => (
				<div key={key} className="audit-chip audit-chip--wide">
					<p className="audit-chip__title">{audit.title}</p>
					<p className="audit-chip__description">
						{audit.description.replace(/\[.*/, "")}
					</p>
				</div>
			))}
		</div>
	);
}

export default Audits;
